import React from 'react';
import PropTypes from 'prop-types';
import KpiTable from '../../../commons/KpiTable';
import { isNaN, isNil } from 'lodash';

const ContentMasteryTestRepeatRateTable = (props) => (
  <KpiTable
    title="Audio listening difficulty"
    description="The number represents the average repeat button usage per item execution. The exercises which represent this number are: Single Choice Text, Single Choice Audio, Single Choice Image, Dictation, Presentation, Short Video, Pronunciation, True or False and Speech Practice."
    loading={props.loading}
    values={props.values}
    currentHigherIsBetter={false}
    onSelect={props.onSelect}
    formatter={props.formatter}
    nameColumnPath={props.nameColumnPath}
    nameColumnRender={props.nameColumnRender}
    additionalColumns={[
      {
        label: 'Executions',
        path: 'totalExecutions',
        sort: true,
        render: (value) => {
          if (isNil(value) || isNaN(value)) {
            return 'N/A';
          }
          return value;
        },
      },
    ]}
    feedbackColorRender={props.feedbackColorRender}
  />
);

ContentMasteryTestRepeatRateTable.propTypes = {
  onSelect: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  values: PropTypes.array.isRequired,
  formatter: PropTypes.func.isRequired,
  feedbackColorRender: PropTypes.func.isRequired,
};

ContentMasteryTestRepeatRateTable.defaultProps = {
  nameColumnPath: 'order',
};

export default ContentMasteryTestRepeatRateTable;
